import "./MechanicalBullPartsAndAccessories.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Catalog from "./sections/Catalog";
import ComponentParts from "./sections/ComponentParts";
import Compatibility from "./sections/Compatibility";
import Controllers from "./sections/Controllers";
import Inflatables from "./sections/Inflatables";
import ReplacementBlowers from "./sections/ReplacementBlowers";
import OlderParts from "./sections/OlderParts";
import Checklist from "./sections/Checklist";
import PartPricing from "./sections/PartPricing";
import Condition from "./sections/Condition";
import ShippingParts from "./sections/ShippingParts";
import PartsFaq from "./sections/PartsFaq";
import Replacement from "./sections/Replacement";
import Footer from "@/reusable_sections/Footer";
export default function MechanicalBullPartsAndAccessoriesPage() {
  return <div>
      <Header />
      <Hero />
      <Catalog />
      <ComponentParts />
      <Compatibility />
      <Controllers />
      <Inflatables />
      <ReplacementBlowers />
      <OlderParts />
      <Checklist />
      <PartPricing />
      <Condition />
      <ShippingParts />
      <PartsFaq />
      <Replacement />
      <Footer />
    </div>;
}